if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.isInitialized = false;
      this.setHeaderCartIconAccessibility();
    }

    init() {
      if (!this.isInitialized) {
        window.loadTemplateContent(this);

        requestAnimationFrame(() => {
          this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          this.moveCssLinks();
          this.isInitialized = true;
        });
      }
    }

    reload() {
      const sections = this.getSectionsToRender().map((section) => section.id);
      fetch(`?sections=${sections}`)
        .then((response) => response.json())
        .then((response) => {
          this.renderContents({
            sections: {
              ...response
            }
          }, true);
        })
        .catch((e) => {
          console.error(e);
        });
    }

    moveCssLinks() {
      const cssLinks = this.querySelectorAll('link[rel="stylesheet"][href*=".css"]');
      cssLinks.forEach(link => {
        const href = link.href;
        if (!document.head.querySelector(`link[href="${href}"]`)) {
          const newLink = link.cloneNode(true);
          document.head.appendChild(newLink);
        }
      });
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      this.init();

      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.removeDeleteTabIndex();

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);

          publish(PUB_SUB_EVENTS.cartOpen);
        },
        {once: true}
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
      publish(PUB_SUB_EVENTS.cartClose);
    }

    removeDeleteTabIndex() {
      this.querySelectorAll('.cart-remove-button').forEach((button) => {
        button.removeAttribute('tabindex');
      });
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState, preventOpen = false) {
      // Close immediately if cart is now empty — do this before DOM updates
      // so trapFocus in CartItems.updateQuantity cannot re-activate the drawer
      if (parsedState.item_count === 0) {
        this.close();
        return;
      }

      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        window.loadTemplateContent(this);
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      });

      this.removeDeleteTabIndex();

      if (theme.settings.cartDrawer.atcAction === 'drawer' && !preventOpen) {
        setTimeout(() => {
          this.open();
        });
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      html = html.replace(/<template\b[^>]*>|<\/template>/g, '');
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  customElements.whenDefined('cart-items').then(() => {
    class CartDrawerItems extends CartItems {
      getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }
    }

    customElements.define('cart-drawer-items', CartDrawerItems);
  });
}

// ─── Bundle Quantity Buttons ───────────────────────────────────────────────────
(function () {

  // ── Flicker prevention ──
  // We snapshot the target qty when the user clicks, then suppress all
  // intermediate DOM mutation updates until the cart section re-renders
  // with the final state. The Liquid already renders buttons with the
  // correct hidden/active states on re-render, so we only need JS to
  // handle the optimistic update on click and re-enable after settle.

  var pendingQty = null;      // qty we're waiting for the cart to settle on
  var settleTimer = null;     // safety-valve timeout to clear pending state

  function log() {
    console.log('[Bundle]', ...arguments);
  }

  // Sum qty across ALL TL1 item rows
  function getTL1TotalQty() {
    var total = 0;
    document.querySelectorAll('[data-is-tl1="true"]').forEach(function(row) {
      var input = row.querySelector('.quantity__input');
      if (input) total += parseInt(input.value, 10) || 0;
    });
    return total;
  }

  // ── Update all bundle button containers for TL1 items ──
  // Uses the qty argument as the definitive source — never reads the DOM
  // mid-flight so intermediate mutation events can't cause flicker.
  function updateBundleButtonsForContainer(container, qty) {
    container.querySelectorAll('.cart-bundle-btn').forEach(function(btn) {
      var targetQty = parseInt(btn.dataset.bundleQty, 10);
      btn.hidden = false;
      btn.classList.toggle('is-active', qty === targetQty);
    });
  }

  function updateBundleButtons(qty) {
    var containers = document.querySelectorAll('.cart-bundle-btns');
    if (!containers.length) return;
    containers.forEach(function(container) {
      updateBundleButtonsForContainer(container, qty);
    });
  }

  // ── Optimistic update on click — instant, no flicker ──
  function onBundleBtnClick(e) {
    var btn = e.target.closest('.cart-bundle-btn');
    if (!btn) return;

    var container = btn.closest('.cart-bundle-btns');
    if (!container) return;

    var itemIndex = container.dataset.itemIndex;
    var targetQty = parseInt(btn.dataset.bundleQty, 10);
    if (!targetQty || !itemIndex) return;

    log('bundle btn clicked, itemIndex=', itemIndex, 'targetQty=', targetQty);

    // Optimistic update using total TL1 qty as base
    pendingQty = targetQty;
    updateBundleButtonsForContainer(container, targetQty);

    clearTimeout(settleTimer);
    applyBundleQty(itemIndex, targetQty);

    settleTimer = setTimeout(function() {
      log('settle timeout — clearing pendingQty');
      pendingQty = null;
    }, 4000);
  }

  function applyBundleQty(itemIndex, targetQty) {
    var cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');

    // Only adjust the FIRST TL1 line item — delta based on total TL1 qty
    var currentTotal = getTL1TotalQty();
    if (currentTotal === targetQty) { log('already at target qty'); return; }

    var delta = targetQty - currentTotal;

    // Find the first TL1 row (index matches itemIndex from container)
    var firstRow = document.querySelector('[data-item-index="' + itemIndex + '"][data-is-tl1="true"]');
    if (!firstRow) { log('no TL1 row at index', itemIndex); return; }

    var input = firstRow.querySelector('.quantity__input');
    var firstQty = input ? parseInt(input.value, 10) : 0;
    var newQty = Math.max(1, firstQty + delta);

    log('currentTotal=', currentTotal, 'targetQty=', targetQty, 'delta=', delta, 'firstQty=', firstQty, 'newQty=', newQty);

    if (cartItemsEl && typeof cartItemsEl.updateQuantity === 'function') {
      cartItemsEl.updateQuantity(itemIndex, newQty);
    } else {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var idx = parseInt(itemIndex, 10) - 1;
          var item = cart.items[idx];
          if (!item) return;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: newQty })
          });
        })
        .then(function(r) { return r && r.json(); })
        .then(function(updated) {
          if (!updated) return;
          var drawerEl = document.querySelector('cart-drawer');
          if (drawerEl && typeof drawerEl.reload === 'function') drawerEl.reload();
        })
        .catch(function(e) { console.error('[Bundle] fallback error', e); });
    }
  }

  // ── Subscribe to cart pub/sub ──
  // On cartUpdate, only update buttons if there's no pending optimistic update
  // in flight — that's what kills the flicker.
  function subscribeToCartEvents() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(subscribeToCartEvents, 500);
      return;
    }

    log('subscribing to cart events');

    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      log('cartUpdate — pendingQty=', pendingQty);

      // Auto-close drawer when cart becomes empty
      if (event && event.cartData && event.cartData.item_count === 0) {
        // Delay so renderContents/trapFocus finishes before we close
        setTimeout(function() {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.close === 'function') drawer.close();
        }, 100);
        return;
      }

      if (pendingQty !== null) {
        log('suppressing intermediate cartUpdate — waiting for re-render');
        return;
      }

      var container = document.getElementById('CartDrawer-BundleBtns');
      if (container) updateBundleButtonsForContainer(container, getTL1TotalQty());
    });

    subscribe(PUB_SUB_EVENTS.cartOpen, function() {
      log('cartOpen');
      var container = document.getElementById('CartDrawer-BundleBtns');
      if (container) updateBundleButtonsForContainer(container, getTL1TotalQty());
    });

    // After the drawer's section HTML re-renders, the Liquid has already
    // output the correct button states — clear pendingQty so future
    // cartUpdate events are processed normally.
    // We detect re-render completion via a MutationObserver on #CartDrawer,
    // but only look for the specific signal that the table was replaced.
    var drawerRoot = document.querySelector('cart-drawer') || document.body;
    var renderSettleTimer;

    new MutationObserver(function(mutations) {
      // Only care about childList changes to the inner drawer (full re-render)
      var isFullRerender = mutations.some(function(m) {
        return m.type === 'childList' &&
               (m.target.id === 'CartDrawer' || m.target.classList.contains('drawer__inner'));
      });

      if (!isFullRerender) return;

      // Debounce — wait for the re-render to fully settle
      clearTimeout(renderSettleTimer);
      renderSettleTimer = setTimeout(function() {
        log('re-render settled — clearing pendingQty');
        pendingQty = null;
        clearTimeout(settleTimer);
        // Re-bind click after re-render replaces the DOM
        bindBundleClicks();
      }, 100);

    }).observe(drawerRoot, { childList: true, subtree: true });
  }

  // ── Bind click listeners ──
  // Delegate from a stable ancestor so re-renders don't orphan listeners
  function bindBundleClicks() {
    var drawerEl = document.getElementById('CartDrawer') || document.querySelector('cart-drawer') || document.body;
    if (drawerEl._bundleBound) return;
    drawerEl._bundleBound = true;
    drawerEl.addEventListener('click', onBundleBtnClick);
    log('bundle clicks bound to', drawerEl.id || drawerEl.tagName);
  }

  function init() {
    log('init');
    bindBundleClicks();
    subscribeToCartEvents();
    var container = document.getElementById('CartDrawer-BundleBtns');
    if (container) updateBundleButtonsForContainer(container, getTL1TotalQty());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();